module.exports = __webpack_public_path__ + "static/media/tacometro-medio-p.cde709c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/contentassets/tacometro-medio-p.svg
// module id = 152
// module chunks = 0